/**
 * Domain Configuration for Fitxero
 *
 * www.fitxero.com  → Marketing site (landing page, pricing, privacy)
 * app.fitxero.com  → SaaS dashboard (login, register, admin, member)
 *
 * Both domains are served from the same Vercel project.
 * This module detects which domain the user is on and exports helpers.
 */

const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

// Marketing/landing page domains
const MARKETING_DOMAINS = ['www.fitxero.com', 'fitxero.com'];

// App domains (dashboard, login, etc.)
const APP_DOMAINS = ['app.fitxero.com'];

/**
 * True when the user is on the marketing/landing page domain (www.fitxero.com)
 */
export const isMarketingSite = MARKETING_DOMAINS.includes(hostname);

/**
 * True when the user is on the app domain (app.fitxero.com) or localhost (dev)
 */
export const isAppSite =
  APP_DOMAINS.includes(hostname) ||
  hostname === 'localhost' ||
  hostname === '127.0.0.1' ||
  hostname.endsWith('.vercel.app'); // Preview deployments act as app

/**
 * Get the app URL for cross-domain links from the marketing site.
 */
export const APP_URL = 'https://app.fitxero.com';

/**
 * Get the marketing site URL for cross-domain links from the app.
 */
export const MARKETING_URL = 'https://www.fitxero.com';
